<label [ngClass]="SwitchStyle == 'rounded' ? 'round' : ''" class="switch">
    <input type="checkbox" [checked]="value" (change)="onChangeFull($event)" (blur)="onTouched()" [disabled]="Disabled">
    <span [ngClass]="SwitchStyle == 'rounded' ? 'round' : ''" class="slider"></span>
</label>
  